import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { CircularProgress, Typography } from '@material-ui/core';

export const Loader = ({ className, ...restProps }) => {
  return (
    <div
      className={cx('flex flex-col items-center justify-center h-screen pb-5', className)}
      {...restProps}
    >
      <CircularProgress size={48} />
      <Typography className="text-base mt-2">Loading document data</Typography>
    </div>
  );
};

Loader.propTypes = {
  className: PropTypes.string,
};
Loader.defaultProps = {
  className: '',
};
